import { render, staticRenderFns } from "./AttractionComparePanel.vue?vue&type=template&id=c5aa0b70&scoped=true"
import script from "./AttractionComparePanel.vue?vue&type=script&lang=js"
export * from "./AttractionComparePanel.vue?vue&type=script&lang=js"
import style0 from "./AttractionComparePanel.vue?vue&type=style&index=0&id=c5aa0b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aa0b70",
  null
  
)

export default component.exports